import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "customer-ranking-button" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", {
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openModal('lightbox-customer-ranking')))
        }, _toDisplayString(_ctx.$t('show-details')), 1)
    ]));
}
